/**
 * Componente raiz da aplicação.
 *
 * A composição da aplicação fica separada do roteamento, do tema e do
 * layout público para manter cada responsabilidade pequena e explícita.
 *
 * @module App
 */

import { AppRouter } from "./app/AppRouter";
import { AppShell } from "./app/AppShell";
import { ThemeProvider, useTheme } from "./app/ThemeProvider";
import { useRouter } from "./hooks/useRouter";

function AppContent() {
  const router = useRouter();
  const { themeMode, toggleTheme } = useTheme();
  const isAdminRoute = router.currentPath.startsWith("/admin");

  if (isAdminRoute) {
    return <AppRouter {...router} themeMode={themeMode} />;
  }

  return (
    <AppShell
      currentPath={router.currentPath}
      navigate={router.navigate}
      themeMode={themeMode}
      toggleTheme={toggleTheme}
    >
      <AppRouter {...router} themeMode={themeMode} toggleTheme={toggleTheme} />
    </AppShell>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}
